import { getExternalSystemsVenuesStatuses } from './getExternalSystemsVenuesStatuses/getExternalSystemsVenuesStatuses';
import { IPublishDestination } from 'src/components/PublishModal/types';
import { IPublication } from '../../types/menu.types';
import { useVenues } from '../useVenues/useVenues';

export const useExternalSystemPublishing = (
  isTrialVenue = false,
  menuPublicationStatus?: IPublication,
  enabled = true,
) => {
  const useQueryResult = useVenues({ enabled });

  if (useQueryResult.isLoading) {
    return useQueryResult;
  }

  const channelsList: IPublishDestination[] = getExternalSystemsVenuesStatuses(
    menuPublicationStatus,
    useQueryResult.data,
    isTrialVenue,
  );
  // only return external systems with more than one venue
  return { ...useQueryResult, data: channelsList.filter((channel: IPublishDestination) => channel.venues.length) };
};
